/**
 * @param {number} relevance
 * @param {number} maxRelevance
 */
export function searchRelevanceToClass(relevance, maxRelevance) {
    const relevanceCoef = Math.round(relevance / maxRelevance * 100);
    let relevanceClass;
    if (relevanceCoef === 100) {
        relevanceClass = 'search-relevance-max';
    } else if (relevanceCoef >= 75) {
        relevanceClass = 'search-relevance-high';
    } else if (relevanceCoef >= 50) {
        relevanceClass = 'search-relevance-middle';
    } else {
        relevanceClass = 'search-relevance-low';
    }

    return relevanceClass;
}



// WEBPACK FOOTER //
// ./src/utils/searchRelevanceToClass.js